<template>
    <div class="wrapper"   v-loading="loading" element-loading-text="正在刷新"> 
        <v-sidebar></v-sidebar>
        <div class="content-box"  :class="{'content-collapse':collapse}">
            <v-head></v-head>
            <v-tags></v-tags>  
            <div class="content" id="content-box" >
                <transition name="move" mode="out-in">
                    <keep-alive :include="cachedViews">
                        <router-view :key="$route.fullPath"></router-view>
                    </keep-alive>
                </transition> 
                <el-backtop target=".content"></el-backtop> 
            </div>
            
        </div>
    </div> 
</template>

<script>

import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from './bus';
 
export default {
    data() {
        return {
            cachedViews: [],
            tagsList: [],
            collapse: false,
            loading: false,
            skinConfig: {
                hover_bgcolor: "rgba(30, 144, 255, 1)",
                hover_color: "rgba(215, 215, 215, 1)",
                left_bgcolor: "rgba(20, 20, 20, 1)",
                left_color: "rgba(215, 215, 215, 1)",
                theme_bgcolor: "rgba(30, 144, 255, 1)",
                theme_color: "rgba(215, 215, 215, 1)",
                theme_type: "1",
                top_bgcolor: "rgba(255, 255, 255, 1)",
                top_color: "rgba(52, 52, 52, 1)",
            }
        }
    },
    components: {
        vHead,
        vSidebar,
        vTags
    },
     created() {
        // 监听tags变化，更新缓存
         bus.$on('collapse-content', msg => {
             this.collapse = msg;

         });
        bus.$on('tags', msg => {
            this.updateCachedViews(msg);
        });
        
        // 监听关闭标签事件，移除对应缓存
        bus.$on('close_tags', (closedTag) => {
            this.removeCachedView(closedTag);
        });

        // 初始化皮肤配置
        this.initSkinConfig();
    },
    methods: {
        initSkinConfig() {
            let skinConfig = localStorage.getItem(window.location.hostname+'_cl_skinConfig');
            if(!skinConfig){
                localStorage.setItem(window.location.hostname+'_cl_skinConfig',JSON.stringify(this.skinConfig));
                skinConfig = JSON.stringify(this.skinConfig);
            }
            var skinData = JSON.parse(skinConfig);
            document.documentElement.style.setProperty('--theme_type', skinData.theme_type);
            document.documentElement.style.setProperty('--theme_bgcolor', skinData.theme_bgcolor);
            document.documentElement.style.setProperty('--theme_color', skinData.theme_color);
            document.documentElement.style.setProperty('--hover_bgcolor', skinData.hover_bgcolor);
            document.documentElement.style.setProperty('--hover_color', skinData.hover_color);
            document.documentElement.style.setProperty('--left_bgcolor', skinData.left_bgcolor);
            document.documentElement.style.setProperty('--left_color', skinData.left_color);
            document.documentElement.style.setProperty('--top_bgcolor', skinData.top_bgcolor);
            document.documentElement.style.setProperty('--top_color', skinData.top_color);
        },
        
        updateCachedViews(tagsList) {
            // 从tagsList中提取需要缓存的组件name
            const newCachedViews = tagsList.map(tag => tag.name).filter(name => name);
            
            // 只更新有变化的缓存
            this.cachedViews = Array.from(new Set(newCachedViews));
        },
        
        removeCachedView(closedTag) {
            if (closedTag && closedTag.name) {
                const index = this.cachedViews.indexOf(closedTag.name);
                if (index > -1) {
                    this.cachedViews.splice(index, 1);
                }
            }
        }
    },
    beforeDestroy() {
        // 清理事件监听
        bus.$off('tags');
        bus.$off('close_tags');
    }

};
</script>
